import React from 'react' 
import Bredcom from '../Bredcom/Main' 
import Header from '../headerone/Main' 


 
function PurchaseCommittee() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="Purchase Committee" />
        <section className="project-detail">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="text-column col-lg-12 col-md-12 col-sm-12">                               
                                <div className="inner-column">
                                    <h2>Purchase Committee</h2>
                                    <table className="table table-bordered mb-40">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Designation</th>                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Rahul Varshney</td>
                                                <td>Chairman</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Mr. Sudhir Dudeja</td>
                                                <td>Member (Finance Representative)</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Mr. Vijay Pahuja</td>
                                                <td>Member</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Indenter (Concern Dean/Head)</td>
                                                <td>Member</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Dr. Devesh Bhatnagar</td>
                                                <td>Member Secretary</td>                                                
                                            </tr>                                                                                       
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        
    </> 
  ) 
} 
 
export default PurchaseCommittee 